import { boot } from 'quasar/wrappers';
import { AxiosInstance } from 'axios';
import { StartUp } from 'SharedDir/utils/centrifuge';

export default boot(({ app, store }) => {
  StartUp(app, store);
});
